export const phoneCodes = [
  { country: "FRANCE", code: "33" },
  { country: "BELGIQUE", code: "32" },
  { country: "SUISSE", code: "41" },
  { country: "ALLEMAGNE", code: "49" },
  { country: "ESPAGNE", code: "34" },
  { country: "ITALIE", code: "39" },
  { country: "ROYAUME-UNI", code: "44" },
  { country: "PORTUGAL", code: "351" },
  { country: "PAYS-BAS", code: "31" },
  { country: "LUXEMBOURG", code: "352" },
  { country: "IRLANDE", code: "353" },
  { country: "ETATS-UNIS", code: "1" },
  { country: "CANADA", code: "1" },
  { country: "AUSTRALIE", code: "61" },
  { country: "NOUVELLE-ZELANDE", code: "64" },
  { country: "BRESIL", code: "55" },
  { country: "ARGENTINE", code: "54" },
  { country: "CHILI", code: "56" },
  { country: "CHINE", code: "86" },
  { country: "JAPON", code: "81" },
  { country: "COREE DU SUD", code: "82" },
  { country: "INDE", code: "91" },
  { country: "RUSSIE", code: "7" },
  { country: "AFRIQUE DU SUD", code: "27" },
  { country: "MAROC", code: "212" },
  { country: "TUNISIE", code: "216" },
  { country: "ALGERIE", code: "213" },
];
